import 'ol/ol.css';
import { Vector as VectorLayer, Heatmap } from 'ol/layer'
import { Vector as VectorSource } from 'ol/source'
import { Style, Stroke, Fill, Text, RegularShape } from 'ol/style.js';
import GeoJSON from "ol/format/GeoJSON";
import Point from "ol/geom/Point";
import { getSourceForGeoJSON, setMapSingleEventHandler } from 'map/OlExtension'
import { getVectorContext } from 'ol/render';
import { unByKey } from 'ol/Observable';
import { getRandomIntInclusive } from 'utils/commonFunc';
import { Circle as CircleStyle } from 'ol/style';

export default class DisplayIntersectionPointLayer extends Heatmap {
    static layerName = "displayIntersection";  
    styleNormal = new Style({
        image: new CircleStyle({
            radius: 10,
            stroke: new Stroke({
                color: 'rgba(255, 0, 0, 1)',
                width: 1,
            }),
            fill: new Fill({
                color: 'rgba( 200, 0, 0, 0.5)'
            })
        }),
    });

    constructor(data) {
        super({
            name: DisplayIntersectionPointLayer.layerName,
            source: getSourceForGeoJSON(data),
            opacity: 1,
            blur: 15,
            radius: 15,
            gradient: ['blue', 'yellow', 'red'],
            weight:(feature) => this.weightFunction(feature)
        });
    }

    weightFunction = function (feature) {        
        const spd = feature.get("spd")
        return spd * 0.1
    };

    updateTraffic = (items) => {
        this.getSource()?.forEachFeature(feature => {
            // const id = feature.get("crsrdId")
            // const spd = items[id];
            // feature.set('spd', spd);
            const spd = getRandomIntInclusive(1, 100);
            feature.set('spd', spd)
        });
    }
}